import React from 'react';
import styled from "styled-components";
import pagesdata from "./data/pagesdata";
import {
  Routes,
  Route,
} from "react-router-dom";
import flatten from './data/flattenarray';
import addpath from './data/addpath';
import Login from './Pages/Login';
import Layout from './Components/Layout';
import Home from './Pages/Home';
import SupportLogin from './Pages/SupportLogin';
import SignupReq from './Pages/SignupReq';
import Signup from './Pages/Signup';
import RequireAuth from './features/auth/RequireAuth'
import {ROLES} from './config/roles'
import PersistLogin from './features/auth/PersistLogin';
import Form_13 from './Components/CPWDForms/Page/Form_13';
import { PDFViewer } from '@react-pdf/renderer';


const Container = styled.div`
  display: flex;
`
const OtherPages = styled.div`
flex: 5;
background-color:lightgreen;
`
const flatarray = flatten(addpath(pagesdata));

const App=() =>{

    return (  
       
      
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Login />} />
          <Route path="/supportlogin" element={<SupportLogin/>}/>
          <Route path="/signupreq" element={<SignupReq/>}/>
          <Route path="/signup" element={<Signup/>}/>
          <Route element={<PersistLogin />}>
            {/* <Route element={<RequireAuth allowedRoles={[...Object.values(ROLES)]} />}> */}
              <Route path="/*" element={<Home />}/>
            {/* </Route> */}
          </Route>
        </Route>
      </Routes>
      )    
}

export default App;

